import TrafficFinesMainHeader from './TrafficFinesMainHeader';
import UsersTableApp from '../Functionality/UsersTableApp';
import CustomTable from '../../../../../components/table/CustomTable';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Users = (props) => {
    const {
        subView,
        handleSubViewChange,
        searchElement,
        setSearchElement,
        setBodyForExport,
        handleOpenModal
    } = props;

    const {
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
        searchResults,
        setSearchResults,
        option,
        rowsPerPage,
        setSimpleSearch,
        simpleSearch,
        setSearch,
        t
    } = UsersTableApp({
        searchElement,
        handleOpenModal,
        setBodyForExport
    });

    return (
        <>
            <TrafficFinesMainHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                DEV={DEV}
                permission={permission}
                searchResults={searchResults}
                setSearchResults={setSearchResults}
                option={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                setBodyForExport={setBodyForExport}
            />
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={DEV}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                textNotInformation={t('no_users_infractions')}
            />
            {pagination()}
        </>
    );
};

export default Users;
